import moment from 'moment';

export function formatDateTime(value) {
  if (!value) return;
  const dateTime = moment(value).format('L') + ' ' + moment(value).format('LT');

  return dateTime;
}

export function formatDate(value) {
  if (!value) return;

  return moment(value).format('L');
}
